import React, { useEffect, useState } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useHttp from "../../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../../constants/driveglobalfilterinitalstates";
import styles from "./Filter_Bus.module.css";
import { useMultivarientVehicleData } from "../context";

const CascadingSelects = (props) => {
    const { sendReq: fetchData } = useHttp();
    const { setGlobalData } = useMultivarientVehicleData();

    const { clearSelectedVinAndReg, clearFilters, localData, setLocalData } = props;

    const [filterdata, setFilterdata] = useState({
        CITY: [],
        DEPO: [],
        ROUTE: [],
    });

    const [options, setOptions] = useState({
        CITY: [],
        DEPO: [],
        ROUTE: [],
    });

    const [selected, setSelected] = useState({
        CITY: null,
        DEPO: null,
        ROUTE: [],
    });

    const [cityKey, setCityKey] = useState(0);

    // =============== CLEAR FILTERS TRIGGER ==================
    useEffect(() => {

        setSelected({
            CITY: null,
            DEPO: null,
            ROUTE: [],
        });

        setFilterdata({
            CITY: [],
            DEPO: [],
            ROUTE: [],
        });

        setOptions((prev) => ({
            ...prev,
            DEPO: [],
            ROUTE: [],
        }));

        // Force remount CITY dropdown
        setCityKey((prev) => prev + 1);

        // clearSelectedVinAndReg();
    }, [clearFilters]);

    // =============== SYNC TO GLOBAL CONTEXT ==================
    useEffect(() => {

        setLocalData((prev) => ({
            ...prev,
            CITY: filterdata.CITY,
            DEPO: filterdata.DEPO,
            ROUTE: filterdata.ROUTE,
            VIN_NUM: [],
            REG_NUM: [],
        }));
        // clearSelectedVinAndReg();
    }, [filterdata]);

    // =============== LOAD CITY OPTIONS ==================
    useEffect(() => {
        const url = `${API_URL_MAIN}ace_multivarient/city`;
        fetchData(
            { url, body: { IND: "CITY_INDEX", filterdata } },
            (data) => {
                const buckets = data?.unique_city?.buckets || [];
                const cityOptions = buckets.map((item) => ({
                    id: item.key.city,
                    value: item.key.city,
                    label: item.key.city.toString(),
                }));
                setOptions((prev) => ({ ...prev, CITY: cityOptions }));
            }
        );
        clearSelectedVinAndReg();

    }, []);

    // =============== LOAD ROUTE WHEN DEPO CHANGES ==================
    useEffect(() => {
        if (!filterdata.DEPO.length) return;

        const url = `${API_URL_MAIN}ace_mileage_sarathi/route`;
        fetchData(
            { url, body: { IND: "ROUTE_INDEX", filterdata } },
            (data) => {
                const buckets = data?.unique_depo?.buckets || [];
                const routeOptions = buckets.map((item) => ({
                    id: item.key.route,
                    value: item.key.route,
                    label: item.key.route.toString(),
                }));

                const finalOptions =
                    routeOptions.length > 0
                        ? [{ label: "All", value: "*" }, ...routeOptions]
                        : [];

                setOptions((prev) => ({ ...prev, ROUTE: finalOptions }));
                setSelected((prev) => ({ ...prev, ROUTE: finalOptions }));
                setFilterdata((prev) => ({ ...prev, ROUTE: [] }));
            }
        );
    }, [filterdata.DEPO, fetchData]);

    // =============== LABEL LOGIC ==================
    const getDropdownLabel = ({ placeholderButtonLabel, value }) => {
        if (Array.isArray(value)) {
            const routeOptions = options.ROUTE.filter((o) => o.value !== "*");

            if (!value.length) return "Select...";

            const allSelected = value.length === routeOptions.length;

            if (value.some((o) => o.value === "*") || allSelected) {
                return "All";
            }

            return `${value.length} selected`;
        }

        if (!filterdata.CITY?.length && placeholderButtonLabel === "Select city")
            return "Select...";
        if (!filterdata.DEPO?.length && placeholderButtonLabel === "Select depo")
            return "Select...";

        return value?.label || placeholderButtonLabel || "Select...";
    };

    // =============== ON CHANGE ==================
    const onChange = (value, event, IND) => {
        if (IND === "CITY_INDEX") {
            const selectedValue = value?.value || "";

            setSelected({
                CITY: value,
                DEPO: null,
                ROUTE: [],
            });

            setFilterdata({
                CITY: selectedValue ? [selectedValue] : [],
                DEPO: [],
                ROUTE: [],
            });

            setOptions((prev) => ({
                ...prev,
                DEPO: [],
                ROUTE: [],
            }));
        }

        if (IND === "DEPO_INDEX") {
            const selectedValue = value?.value || "";

            setSelected((prev) => ({
                ...prev,
                DEPO: value,
                ROUTE: [],
            }));

            setFilterdata((prev) => ({
                ...prev,
                DEPO: selectedValue ? [selectedValue] : [],
                ROUTE: [],
            }));

            setOptions((prev) => ({
                ...prev,
                ROUTE: [],
            }));
        }

        if (IND === "ROUTE_INDEX") {
            const extractedValues = (value || []).map((v) => v.value);

            if (event?.option?.value === "*") {
                if (event.action === "select-option") {
                    setSelected((prev) => ({ ...prev, ROUTE: options.ROUTE }));
                    setFilterdata((prev) => ({ ...prev, ROUTE: [] }));
                } else {
                    setSelected((prev) => ({ ...prev, ROUTE: [] }));
                    setFilterdata((prev) => ({ ...prev, ROUTE: [] }));
                }
            } else {
                const filtered = (value || []).filter((v) => v.value !== "*");

                setSelected((prev) => ({ ...prev, ROUTE: filtered }));

                setFilterdata((prev) => ({
                    ...prev,
                    ROUTE:
                        filtered.length === options.ROUTE.length - 1
                            ? []
                            : filtered.map((v) => v.value),
                }));
            }
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <div
                    className={`mb-1 ${styles.date_range_selection}`}
                    style={{ fontWeight: "bold", color: "#364e69" }}
                >
                    Select City
                </div>
                <ReactMultiSelectCheckboxes
                    key={cityKey}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={options.CITY}
                    value={selected.CITY || null}
                    onChange={(val, evt) => onChange(val, evt, "CITY_INDEX")}
                    getDropdownButtonLabel={getDropdownLabel}
                    placeholderButtonLabel="Select city"
                    isMulti={false}
                />
            </div>
        </div>
    );
};

export default CascadingSelects;
